/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DoctorEntity } from './DoctorEntity';
import {
    DoctorEntityFromJSON,
    DoctorEntityFromJSONTyped,
    DoctorEntityToJSON,
} from './DoctorEntity';

/**
 * 
 * @export
 * @interface DoctorControllerGetDoctors200Response
 */
export interface DoctorControllerGetDoctors200Response {
    /**
     * 
     * @type {number}
     * @memberof DoctorControllerGetDoctors200Response
     */
    count: number;
    /**
     * 
     * @type {Array<DoctorEntity>}
     * @memberof DoctorControllerGetDoctors200Response
     */
    data: Array<DoctorEntity>;
}

/**
 * Check if a given object implements the DoctorControllerGetDoctors200Response interface.
 */
export function instanceOfDoctorControllerGetDoctors200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DoctorControllerGetDoctors200ResponseFromJSON(json: any): DoctorControllerGetDoctors200Response {
    return DoctorControllerGetDoctors200ResponseFromJSONTyped(json, false);
}

export function DoctorControllerGetDoctors200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorControllerGetDoctors200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'data': ((json['data'] as Array<any>).map(DoctorEntityFromJSON)),
    };
}

export function DoctorControllerGetDoctors200ResponseToJSON(value?: DoctorControllerGetDoctors200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'data': ((value.data as Array<any>).map(DoctorEntityToJSON)),
    };
}

